import { render, staticRenderFns } from "./coach_billing_plans.vue?vue&type=template&id=52cc5f70&"
import script from "./coach_billing_plans.vue?vue&type=script&lang=js&"
export * from "./coach_billing_plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports